module.exports = __webpack_public_path__ + "img/inviteUser.2af6d171.svg";